import { CellContext, createColumnHelper } from "@tanstack/react-table";
import React, { useState } from "react";
import { Col } from "react-bootstrap";
import IConfirmacionMantenedor from "../../../entities/helper/IConfirmacionMantenedor";
import ILogMantenedor from "../../../entities/ILogMantenedor";
import { shortDate } from "../../../helpers/dateHelper";
import { ITipo_Campo } from "../../../helpers/IFormHelper";
import { getAPI } from "../../../helpers/httpHelper";
import { usePromiseEffect } from "../../../helpers/promiseEffect";
import { cognitoUserToken } from "../../../helpers/userHelper";
import { API_ADMIN_LOG_MANTENEDOR, ROW_COUNT, URL_SUPPORT } from "../../../helpers/variableHelper";
import AdminLista from "../AdminLista";
import Select from "react-select";
import { IComboboxOption } from "../../../entities/helper/IComboboxOption";
import { cParams } from "../../../helpers/paramsHelper";
import { downloadFile } from "../../../helpers/fileHelper";
import RenderTitle from "../../../controls/RenderTitle";
import RenderValue from "../../../controls/RenderValue";
interface IHistoriaCambiosProps {
  items?: Array<any>;
  ItemsConfirmacion?: Array<IConfirmacionMantenedor>;
}

export default function HistoriaCambios({ items, ItemsConfirmacion }: IHistoriaCambiosProps) {
  let params = cParams;
  const userInfo = cognitoUserToken();
  const [token, setToken] = useState("");
  const [listItems, setListItems] = useState<Array<any>>(items || []);
  const [isLoading, setIsLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [pages, setPages] = useState(0);
  const [arrCambiosForm] = useState<Array<IConfirmacionMantenedor>>(ItemsConfirmacion || []);
  const [isOpenPopUpGuardarCambios, setIsOpenPopUpGuardarCambios] = useState<boolean>(false);
  const [pageSize, setPageSize] = useState(ROW_COUNT);
  const [refComboModulo, setValComboModulo] = useState<IComboboxOption | null>(null);

  const component = (titulo: string) => {
    return <RenderTitle title={titulo} />;
  };

  const componentValue = (value: any) => {
    return <RenderValue value={value} />;
  };

  const columnHelperHistoricoCambios = createColumnHelper<ILogMantenedor>();
  usePromiseEffect(async () => {
    setIsLoading(true);

    let token = await userInfo;
    setToken(token);
    let params = { PAGINA: 1, PAGINADO: pageSize, ORDENADOPOR: "ID", ORIENTACION: "DESC" };
    getAPI(`${URL_SUPPORT}${API_ADMIN_LOG_MANTENEDOR}/getall`, { Authorization: `Bearer ${token}` }, params)
      .then((result) => {
        setListItems(result.result.data);
        setIsLoading(false);
      })
      .catch((error) => {
        setIsLoading(false);
        console.log(error);
      });
  }, []);

  let columnsDef = [
    columnHelperHistoricoCambios.accessor((row) => row.MODULO, {
      id: "MODULO",
      cell: (info: CellContext<ILogMantenedor, string>) => componentValue(info.getValue()),
      header: () => component("Módulo"),
      hide: false,
      title: "Módulo",
      tipo: ITipo_Campo.text,
      className: "colorGris",
    } as any),
    columnHelperHistoricoCambios.accessor((row) => row.TABLA, {
      id: "TABLA",
      cell: (info: CellContext<ILogMantenedor, string>) => componentValue(info.getValue()),
      header: () => component("Tabla"),
      hide: false,
      title: "Tabla",
      tipo: ITipo_Campo.text,
      className: "colorGris",
    } as any),
    columnHelperHistoricoCambios.accessor((row) => row.ID_REGISTRO, {
      id: "ID_REGISTRO",
      cell: (info: CellContext<ILogMantenedor, string>) => componentValue(info.getValue()),
      header: () => component("ID Registro"),
      hide: false,
      title: "ID Registro",
      tipo: ITipo_Campo.text,
      className: "colorGris",
    } as any),
    columnHelperHistoricoCambios.accessor((row) => row.CORRELATIVO, {
      id: "CORRELATIVO",
      cell: (info: CellContext<ILogMantenedor, string>) => componentValue(info.getValue()),
      header: () => component("Correlativo"),
      hide: false,
      title: "Correlativo",
      tipo: ITipo_Campo.text,
      className: "colorGris",
    } as any),
    columnHelperHistoricoCambios.accessor((row) => row.CAMPO, {
      id: "CAMPO",
      cell: (info: CellContext<ILogMantenedor, string>) => componentValue(info.getValue()),
      header: () => component("Campo"),
      hide: false,
      title: "Campo",
      tipo: ITipo_Campo.text,
      className: "colorGris",
    } as any),
    columnHelperHistoricoCambios.accessor((row) => row.VALOR_INICIAL, {
      id: "VALOR_INICIAL",
      cell: (info: CellContext<ILogMantenedor, string>) => componentValue(info.getValue()),
      header: () => component("Valor Antiguo"),
      hide: false,
      title: "Valor Antiguo",
      tipo: ITipo_Campo.text,
      className: "colorGris",
    } as any),
    columnHelperHistoricoCambios.accessor((row) => row.VALOR_FINAL, {
      id: "VALOR_FINAL",
      cell: (info: CellContext<ILogMantenedor, string>) => componentValue(info.getValue()),
      header: () => component("Valor Nuevo"),
      hide: false,
      title: "Valor Nuevo",
      tipo: ITipo_Campo.text,
      className: "colorGris",
    } as any),
    columnHelperHistoricoCambios.accessor((row) => row.MOTIVO, {
      id: "MOTIVO",
      cell: (info: CellContext<ILogMantenedor, string>) => componentValue(info.getValue()),
      header: () => component("Motivo"),
      hide: false,
      title: "Motivo",
      tipo: ITipo_Campo.text,
      className: "colorGris",
    } as any),
    columnHelperHistoricoCambios.accessor((row) => row.AUTOR_DISPLAY, {
      id: "AUTOR",
      cell: (info: CellContext<ILogMantenedor, string>) => componentValue(info.getValue()),
      header: () => component("Autor"),
      hide: false,
      title: "Autor",
      tipo: ITipo_Campo.text,
      className: "colorGris",
    } as any),
    columnHelperHistoricoCambios.accessor((row) => shortDate(row.FECHA_MODIFICACION as Date), {
      id: "FECHA_MODIFICACION",
      cell: (info: CellContext<ILogMantenedor, string>) => componentValue(info.getValue()),
      header: () => component("Fecha Modificación"),
      hide: false,
      title: "Fecha Modificación",
      tipo: ITipo_Campo.date,
      className: "colorGris",
    } as any),
    columnHelperHistoricoCambios.accessor((row) => row.ACCION, {
      id: "ACCION",
      cell: (info: CellContext<ILogMantenedor, string>) => componentValue(info.getValue()),
      header: () => component("Acción"),
      hide: false,
      tipo: ITipo_Campo.text,
      className: "colorGris",
    } as any),
  ] as any;

  const exportFile = () => {
    const valModulo = refComboModulo?.value;
    let parameters = params as any;
    parameters.MODULO = valModulo;

    getAPI(`${URL_SUPPORT}${API_ADMIN_LOG_MANTENEDOR}/export`, { Authorization: `Bearer ${token}` }, params).then((r) => {
      downloadFile(r.result);
    });
  };

  const paging = (page: any) => {
    setPage(page);
    filter({ PAGINA: page }, true);
  };

  const filter = (filter: any, page: boolean = false, size = pageSize) => {
    setIsLoading(true);
    if (!filter) {
      filter = {};
    }

    filter.TIPO_FACTOR = filter.ID_TIPO_FACTOR?.toString() || "";
    filter.PAGINADO = size;
    if (filter.PAGINA === undefined) {
      filter.PAGINA = 1;
    }
    if (!page) {
      filter.PAGINA = 1;
    }
    setPage(filter.PAGINA);
    if (filter.ORDENADOPOR === undefined) {
      filter.ORDENADOPOR = "ID";
      filter.ORIENTACION = "DESC";
    }

    const valModulo = refComboModulo?.value;
    if (valModulo !== undefined) {
      filter.MODULO = valModulo;
    }

    getAPI(`${URL_SUPPORT}${API_ADMIN_LOG_MANTENEDOR}/getall`, { Authorization: `Bearer ${token}` }, filter)
      .then((result) => {
        setListItems(result.result.data);
        setIsLoading(false);
        let pages = result.result.pages;
        setPages(pages);
      })
      .catch((error) => {
        setIsLoading(false);
        console.log(error);
      });
  };

  const edit = (value: any, filters: any) => {
    delete value.FECHA_CREACION;
    delete value.TRANSACTION_ID;
    value.AUTOR = "";
    value.AUTOR_DISPLAY = "";
    value.EDITOR = "";
    value.EDITOR_DISPLAY = "";

    if (value.ID === "") {
      delete value.ID;
    }
  };

  return (
    <section>
      <div className="row">
        <button
          hidden={true}
          data-testid="btnedit"
          onClick={() => {
            edit({ AUTOR: "", AUTOR_DISPLAY: "", EDITOR: "", EDITOR_DISPLAY: "", ID: "" }, {});
          }}></button>
        <div className="col-12">
          <div className="rounded bg-white p-2 shadow">
            <div className="container-fluid mb-2">
              <h1 className="titPrincipal colorTit mt-2">Histórico Modificaciones</h1>
              <div className="alert alert-warning p-1 mb-2" role="alert">
                <i className="text-info bi bi-info-circle-fill me-2"></i>
                <small>
                  <strong>Nota:</strong> Esta grilla muestra todos los cambios registrados mediante el mantenedor de cada modulo
                </small>
              </div>
              <div className="row mb-2 ajusteInput">
                <Col xs="12" md="6" lg="6">
                  <label>Módulo:</label>
                  <Select
                    placeholder="Seleccione"
                    value={refComboModulo || ""}
                    isClearable={true}
                    noOptionsMessage={({ inputValue }) => (!inputValue ? "No se han encontrado resultados" : "")}
                    options={[
                      { value: "DESVIACIONES", label: "DESVIACIONES" },
                      { value: "LIOS", label: "LIOS" },
                      { value: "AUDITORÍA", label: "AUDITORÍA" },
                      { value: "PROVEEDORES", label: "PROVEEDORES" },
                    ]}
                    onChange={async (e: any) => {
                      setValComboModulo(e);
                    }}
                  />
                </Col>
              </div>
              <div className="row mb-2 mt-2">
                <Col xs="12" md="12" lg="12">
                  <button
                    className="btn btn-primary btn-sm me-2"
                    data-testid="btnbuscar"
                    onClick={async () => {
                      const valModulo = refComboModulo?.value;
                      let params = {
                        PAGINA: 1,
                        PAGINADO: ROW_COUNT,
                        ORDENADOPOR: "ID",
                        ORIENTACION: "DESC",
                        MODULO: valModulo,
                      };
                      const result = (await getAPI(`${URL_SUPPORT}${API_ADMIN_LOG_MANTENEDOR}/getall`, { Authorization: `Bearer ${token}` }, params))
                        .result;
                      let list = result.data;
                      console.log(list);
                      setListItems(list);
                      let pages = result.pages;
                      setPages(pages);
                    }}>
                    {" "}
                    <i className="bi bi-search"></i> Buscar
                  </button>
                  <button
                    className="btn btn-outline-primary btn-sm me-2"
                    onClick={() => {
                      setValComboModulo(null);
                      setListItems([]);
                    }}>
                    {" "}
                    <i className="bi bi-stars"></i> Limpiar Campos
                  </button>

                  {arrCambiosForm.length > 0 && (
                    <button
                      className="btn btn-secondary btn-sm me-2"
                      onClick={() => {
                        setIsOpenPopUpGuardarCambios(true);
                      }}>
                      {" "}
                      <i className="bi bi-check"></i> Guardar Cambios
                    </button>
                  )}
                </Col>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row mb-1">
        <AdminLista
          reload={filter}
          items={[]}
          callback={edit}
          exportar={exportFile}
          data={listItems}
          tipo={"MantenedorDesviaciones"}
          filter={filter}
          pagination={{ pages: pages, page: page, paging: paging }}
          title=""
          hideAdd={true}
          hideExport={false}
          columnsDef={columnsDef}
          callbackUpdatePageSize={(pageSize: number, filters: Object) => {
            setPageSize(pageSize);
            filter(filters, false, pageSize);
          }}
          isLoading={isLoading}
        />
      </div>
    </section>
  );
}
